import { useMemo } from 'react';

import { useHasFeatureFlag } from 'bringg-web/utils/feature-flags';
import { ALERTS_ADDITIONAL_TEXT_FF } from 'bringg-web/consts';
import { ALERT_DYNAMIC_COLUMN_IDS } from 'bringg-web/stores/alerts-view/consts';

type BaseColumn = { id: string };

// https://bringg.atlassian.net/browse/BRNGG-29287
const useFilteredAlertColumns = <T extends BaseColumn>(columns: T[]): T[] => {
	const alertAdditionalText = useHasFeatureFlag(ALERTS_ADDITIONAL_TEXT_FF);

	return useMemo(
		() =>
			columns.filter(c => {
				if (!alertAdditionalText) {
					return c.id !== ALERT_DYNAMIC_COLUMN_IDS.AdditionalText;
				}
				return true;
			}),
		[columns, alertAdditionalText]
	);
};

export default useFilteredAlertColumns;
